import React from 'react';

import { useIntl } from 'react-intl-next';

import Button, { type ButtonProps } from '@atlaskit/button/new';

import { messages } from '../../../../../messages';

interface OwnProps {
	nextButtonOnClick: (() => void) | undefined;
	nextButtonAppearance: ButtonProps['appearance'] | undefined;
	isNextButtonDisabled: boolean | undefined;
	isSubmissionLoading: boolean | undefined;
	nextButtonText: string | undefined;
	formId: string | undefined;
	testId: string;
}

export const SubmitButton = ({
	formId,
	nextButtonOnClick,
	nextButtonAppearance,
	isNextButtonDisabled,
	isSubmissionLoading,
	nextButtonText,
	testId,
}: OwnProps) => {
	const { formatMessage } = useIntl();

	const handleOnClick = async (event: React.FormEvent) => {
		event.preventDefault();
		const form = document.getElementById(formId || '');

		if (form) {
			await new Promise((resolve) => {
				// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
				form?.addEventListener('submit', resolve, { once: true });
				(form as HTMLFormElement).requestSubmit();
			});
		}

		// nextButtonOnClick needs to come after form.submit() to ensure the form is submitted before the next step is triggered
		nextButtonOnClick?.();
	};

	return (
		<Button
			testId={`${testId}-footer-submit-button`}
			onClick={handleOnClick}
			appearance={nextButtonAppearance || 'primary'}
			form={formId}
			type="submit"
			isDisabled={isNextButtonDisabled || isSubmissionLoading}
			isLoading={isSubmissionLoading}
		>
			{nextButtonText || formatMessage(messages.defaultNextButtonText)}
		</Button>
	);
};
